import apiClient from './api.service';
import { SurveyLandingData } from '../types/survey-landing.types';

class SurveyLandingService {
  async getLandingData(surveyHash: string): Promise<SurveyLandingData> {
    const response = await apiClient.get<{ data: SurveyLandingData }>(
      `/api/public/surveys/${surveyHash}/landing`
    );
    return response.data.data;
  }
}

export const surveyLandingService = new SurveyLandingService();
